<!-- <ng-container *ngIf="isMenuOpen; else menuList">
    <div class="list-container">
        <ng-container *ngFor="let section of sectionList">
            <div
                class="anchor-line"
                [class.selectedSection]="currentSectionIndex == section.index"
            ></div>
        </ng-container>
    </div>
</ng-container>

<ng-template #menuList>
    <div class="open-menu-container">
        <ng-container *ngFor="let section of sectionList">
            <div
                class="section-item"
                [class.selectedSection]="currentSectionIndex == section.index"
                (click)="selectSection(section)"
            >
                {{ section.title | translate }}
            </div>
        </ng-container>
    </div>
</ng-template> -->

<div class="section-nav-wrapper">
    <div class="list-container">
        <ng-container *ngFor="let section of sectionList">
            <div class="anchor-line" [class.selectedSection]="currentSectionIndex == section.index"></div>
        </ng-container>
    </div>

    <div class="open-menu-container">
        <ng-container *ngFor="let section of sectionList">
            <div
                class="section-item"
                [class.selectedItem]="currentSectionIndex == section.index"
                (click)="selectSection(section)">
                {{ section.title | translate }}
            </div>
        </ng-container>
    </div>
</div>
